import { Box, Button, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useContext, useMemo, useState } from 'react'
import { ThemeContext } from '../../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import CryptoJS from "crypto-js";
import toast from "react-hot-toast";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { changePassword } from '../../../api/request/auth'

export default function ChangePin({ setActivePage }) {
    const { darkMode } = useContext(ThemeContext)
    const { t } = useTranslation()
    const [passwordDetails, setPasswordDetails] = useState({ oldPassword: "", newPassword: "", confirmPassword: "", });
    const savedCredentials = useMemo(() => JSON.parse(localStorage.getItem("savedCredentials") || "{}"), []);
    const SECRET_KEY = process.env.REACT_APP_SECRET_KEY
    const [showPassword, setShowPassword] = useState({ new: false, confirm: false, });
    const clientId = localStorage.getItem('clientId')
    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordDetails({ ...passwordDetails, [name]: value });
    };
    const handlePasswordSubmit = async (e) => {
        e.preventDefault();

        try {
            const encryptedData = savedCredentials.password;

            const iv = CryptoJS.enc.Base64.parse(encryptedData.substr(0, 24));
            const encryptedPassword = encryptedData.substring(24);

            const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
            const bytes = CryptoJS.AES.decrypt(encryptedPassword, key, { iv });
            const decryptedPassword = bytes.toString(CryptoJS.enc.Utf8);

            if (decryptedPassword !== passwordDetails.oldPassword) {
                toast.error("Old password is incorrect.");
                return;
            }

            if (passwordDetails.newPassword !== passwordDetails.confirmPassword) {
                toast.error("New password and confirm password do not match!");
                return;
            }

            const payload = {
                clientId: clientId,
                oldPassword: passwordDetails.oldPassword,
                newPassword: passwordDetails.newPassword,
                confirmPassword: passwordDetails.confirmPassword
            };

            const res = await changePassword(payload);

            if (res?.status === 200) {
                toast.success("PIN changed successfully!");

                const newIv = CryptoJS.lib.WordArray.random(16);
                const newEncrypted = CryptoJS.AES.encrypt(passwordDetails.newPassword, key, { iv: newIv });
                const newEncryptedPassword = CryptoJS.enc.Base64.stringify(newIv) + newEncrypted.toString();

                const updatedCredentials = {
                    ...savedCredentials,
                    password: newEncryptedPassword,
                };

                localStorage.setItem("savedCredentials", JSON.stringify(updatedCredentials));
                setActivePage(null);
            } else {
                toast.error(res?.data?.message || "Failed to change PIN.");
            }

        } catch (err) {
            console.error("Password change error:", err);
            toast.error("Something went wrong while verifying or updating your PIN.");
        }
    };
    const toggleVisibility = (field) => {
        setShowPassword(prev => ({ ...prev, [field]: !prev[field] }));
    };
    const getAdornment = (fieldKey) => (
        <InputAdornment position="end">
            <IconButton onClick={() => toggleVisibility(fieldKey)} edge="end">
                {showPassword[fieldKey] ? <VisibilityOff /> : <Visibility />}
            </IconButton>
        </InputAdornment>
    );

    return (
        <>
            <Box sx={{ px: 2, py: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <IconButton onClick={() => setActivePage(null)}>
                        <ArrowBackIosNewIcon fontSize="small" />
                    </IconButton>
                    <Typography sx={{ ml: 1, fontSize: '14px', color: darkMode ? 'white' : 'black' }}>{t("changePin")}</Typography>
                </Box>
                <Grid container spacing={1.5} sx={{ padding: 0 }} alignItems="center">
                    <Grid item xs={12}><Typography textAlign='left' variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('enterCurrentPin')}</Typography></Grid>
                    <Grid item xs={12}><TextField name="oldPassword" type="password" fullWidth size="small" required value={passwordDetails.oldPassword} onChange={handlePasswordChange} className="custom-textfield" /></Grid>
                    <Grid item xs={12}><Typography textAlign='left' variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }} >{t('enterNewPin')}</Typography></Grid>
                    <Grid item xs={12}><TextField InputProps={{ endAdornment: getAdornment("new") }} type={showPassword.new ? "text" : "password"} fullWidth size="small" required name="newPassword" value={passwordDetails.newPassword} onChange={handlePasswordChange} className="custom-textfield" /></Grid>
                    <Grid item xs={12}><Typography textAlign='left' variant="body2" sx={{ color: darkMode ? "var(--lightText)" : 'var(--black)' }}>{t('confirmPin')}</Typography></Grid>
                    <Grid item xs={12}><TextField InputProps={{ endAdornment: getAdornment("confirm") }} name="confirmPassword" type={showPassword.confirm ? "text" : "password"} fullWidth size="small" required value={passwordDetails.confirmPassword} onChange={handlePasswordChange} className="custom-textfield" /></Grid>
                    <Grid container spacing={1} px={1} mt={1}>
                        <Grid item xs={12}><Button fullWidth type="submit" variant="contained" onClick={handlePasswordSubmit} sx={{ border: '1px solid #00398F', background: 'linear-gradient(to right, #00398F, #0057D9)', color: "white", padding: "5px", textTransform: "none", }}>{t('changePassword')}</Button></Grid>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
